export const invoiceTemplates = {
  actions: {
    create: 'Create invoice template',
    createInvoice: 'Create invoice',
    delete: 'Delete',
    details: 'More details',
    edit: 'Edit',
    pause: 'Pause',
    unpause: 'Set live',
  },
  alerts: {
    successCreated: 'Your invoice template has been created.',
    successDeleted: 'Your invoice template has been deleted.',
    successUpdated: 'Your invoice template has been updated.',
  },
  breadcrumb: {
    create: 'Create invoice template',
    noTitle: 'No title',
    overview: 'Invoice templates',
  },
  breadcrumbs: {
    index: 'All invoice templates',
    show: 'Invoice template details',
  },
  createEdit: {
    blocker: {
      create: 'Are you sure you want to leave this page? Your invoice template has not been saved.',
      edit: 'Are you sure you want to leave this page? Your changes have not been saved.',
    },
    fields: {
      interval: {
        label: 'Create periodically',
      },
      nextInvoiceAt: {
        label: 'Next invoice',
      },
      paymentTerm: {
        helpText: 'The due date will be {{days}} days after the invoice date.',
        helpTextEndOfMonth: 'The due date will be {{days}} days after the end of the month of the invoice date.',
      },
    },
    header: {
      title: {
        create: 'New invoice template',
        edit: 'Edit invoice template',
      },
    },
    preview: 'Invoice preview',
    unpauseModal: {
      description: 'Your invoice template isn’t active.\n<break/>Reactivate it? The next invoice will be created on {{nextInvoiceAt}}.',
      keepPaused: 'Leave inactive',
      title: 'Resume periodic invoices',
      unpause: 'Reactivate',
    },
  },
  deleteModal: {
    description: 'Are you sure you want to delete this invoice template?',
    submit: 'Delete invoice template',
    title: 'Delete invoice template',
  },
  details: {
    error: {
      title: 'Error loading your invoice template.',
    },
    intervalStatusTooltip: {
      Live: 'Your invoice template is active, invoices are created periodically.',
      Paused: 'Your invoice template isn’t active, your invoices aren’t created periodically.',
    },
    invoices: {
      noInvoicesMessage: 'No invoices have been created with this invoice template yet.',
      title: 'Invoices',
      titleWithCount: 'Invoices ({{amount}})',
    },
    stats: {
      nextInvoice: {
        label: 'Next invoice',
        tooltip: 'On this day, a new draft invoice is automatically created for you, based on this template.',
      },
      recurring: {
        label: 'Create periodically',
        tooltip: 'How often your invoices are created.',
      },
      totalAdvantage: {
        label: 'Total benefit',
        tooltip: 'The total benefit of all invoices you’ve created with this template.',
      },
      totalInvoices: {
        label: 'Number of invoices',
        tooltip: 'Total number of periodic invoices created with this template.',
      },
    },
    summary: {
      title: 'Overview',
    },
  },
  overview: {
    columns: {
      client: 'Client',
      nextInvoiceAt: 'Next invoice',
      title: 'Title',
      total: 'Total (excl. VAT)',
      type: 'Type',
    },
    error: {
      title: 'Error loading your invoice templates.',
    },
    header: {
      title: 'Invoice templates',
    },
  },
  terminology: {
    interval: {
      cases: {
        Disabled: 'Disabled',
        Monthly: 'Monthly',
        Quarterly: 'Every quarter',
        Weekly: 'Weekly',
      },
    },
    intervalStatus: {
      cases: {
        Live: 'Live',
        Paused: 'Paused',
      },
    },
    invoiceTemplate: 'Invoice template',
    templateType: {
      cases: {
        Manual: 'Manual',
        Recurring: 'Periodic',
      },
    },
  },
};
